/**
 * Design tokens — clone exact palette từ project Old `AOF_DangKyTinChi_Old/wwwroot/css/style.scss`.
 * SV đã quen Old + có video hướng dẫn → giữ palette + font giống hệt để không lệch.
 */

export const colors = {
    // ===== Old palette (giữ nguyên giá trị từ style.scss) =====
    /** Primary blue (Bootstrap btn-primary). */
    primary: "#007bff",
    primaryHover: "#0069d9",
    primaryActive: "#0056b3",
    /** Light blue accent — active row, tab active, section title pill. */
    primarySubtle: "#c3dcff",

    /** Lock state — yellow bg (lớp full slot / trùng TKB). */
    lockBg: "#ffffcc",

    success: "#28a745",
    successHover: "#218838",
    successSubtle: "#d4edda",
    danger: "#ef1c1c",
    dangerHover: "#dc3545",
    dangerSubtle: "#f8d7da",
    info: "#17a2b8",
    warning: "#ffc107",
    warningSubtle: "#fff3cd",

    // Text + neutrals
    text: "#333333",
    textMuted: "#6c757d",
    textLight: "#888",
    border: "#dee2e6",
    borderMuted: "#e9ecef",
    background: "#ffffff",
    backgroundInset: "#f8f9fa",
    tableHeaderBg: "#e9e9e9",  // thead background

    // Footer
    footerBg: "#777777",
    footerText: "#ffffff",
    copyrightBg: "#666666",
    copyrightText: "#eeeeee",

    // Aliases (legacy compat)
    accent: "#c3dcff",
    accentSubtle: "#c3dcff",
} as const;

export const spacing = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
    xxl: 6,
} as const;

export const typography = {
    /** Font stack Bootstrap 5 (Old project thực tế dùng — CDN Bootstrap override style.scss). */
    fontFamily:
        'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    fontFamilyBody:
        'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    fontSize: {
        xs: "11px",
        sm: "12px",
        base: "14px",   // body Old
        md: "15px",
        lg: "16px",
        xl: "17px",     // header brand Old
        h2: "20px",
        h1: "24px",
    },
    fontWeight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
    },
} as const;

export const radii = {
    sm: 1,    // 2px (Bootstrap default)
    md: 1,    // 4px buttons
    lg: 2,    // 5px sections
    xl: 4,    // 12-20px login form
    pill: "999px",
} as const;

export const shadows = {
    sm: "0 1px 3px rgba(0,0,0,0.06)",
    md: "0 0 10px rgba(0,0,0,0.2)",   // Old shadow
    lg: "0 6px 14px rgba(0,0,0,0.25)",
} as const;

export const layoutDimensions = {
    headerHeight: "auto",
    contentMaxWidth: "100%",
    contentPadding: "15px",
} as const;
